import React from 'react';
import { motion } from 'framer-motion';
import { EyeIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { heroChips, heroTrust } from '../data/hero';
export function Hero() {
  return <header className="bg-radial-glow relative overflow-hidden" data-id="element-85" data-mp="9k0g9cbeknrr">
      <div className="mx-auto max-w-4xl px-5 pb-6 pt-[15px] text-center" data-id="element-86" data-mp="4lqj4w64bd3i">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: [0.23, 1, 0.32, 1]
      }} className="text-[10px] font-extrabold uppercase tracking-[0.25em] text-grape" data-id="element-87" data-mp="4njnu5x67n8v">
          🌸 SIGMA SMART™
        </motion.p>

        <p className="mx-auto mt-3 max-w-2xl font-display text-[22px] font-bold leading-tight text-plum sm:text-[30px]" data-id="element-88" data-mp="nc858hwg3afw">
          Beherrsche Koreanisch fließend in 60 Minuten
        </p>

        
        <p className="pb-[15px] font-display text-xs font-bold uppercase tracking-[0.3em] text-plum/60 sm:text-base" style={{
        paddingTop: "9px",
        paddingBottom: "20px"
      }} data-id="element-89" data-mp="382ffxqfwf8fz">
          LERNE HANGUL VON GRUND AUF MIT EINER VISUELLEN METHODE LESEN
        </p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto w-full max-w-md" data-id="element-90" data-mp="3o73p8bldju82">
          <div className="absolute inset-0 -z-10 mx-auto h-64 w-64 translate-y-6 rounded-full bg-grape/20 blur-3xl" aria-hidden="true" data-id="element-91" data-mp="30h9b7qpbjzm8" />
          <img src="https://cdn.magicpatterns.com/uploads/uMtWBQ134HxqoMTp5EhoM7/ChatGPT_Image_1_sept_2026,_21_01_57.png" alt="K-Visual Masterplan™ — eBook plus 5 Boni im digitalen Format" width={1248} height={1248} className="animate-floaty mx-auto aspect-square w-full max-w-full rounded-2xl object-contain" data-id="element-92" data-mp="35au9ljutqvly" />
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.05
      }} className="mt-4 text-xs font-semibold uppercase tracking-[0.18em] text-plum/50" data-id="element-93" data-mp="2lla6mq1f4hlu">
          ⭐ 4.9 (500+ zufriedene Schüler) · ⚡ Sofortiger Zugriff
        </motion.p>

        <div className="mt-8 flex flex-col items-center" data-id="element-94" data-mp="id02aln7dwm0">
          <CTAButton href="#value" data-id="element-95" data-mp="ddf2ya44fm8r">K-Visual Masterplan™ jetzt holen</CTAButton>

          <p className="mx-auto mt-4 max-w-2xl text-[14px] text-plum/70 sm:text-lg" data-id="element-96" data-mp="dbaoiy8lj4u8">
            Beginne Koreanisch von null an zu verstehen, auch wenn du noch nie eine Sprache gelernt
            hast. Lerne Hangeul, echte Sätze, den wesentlichen Wortschatz und K-Drama- / K-Pop-
            Ausdrücke mit einer visuellen, einfachen und klar organisierten Methode.
          </p>

          <motion.h2 initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="mx-auto mt-4 max-w-2xl text-[16px] font-bold text-plum-soft sm:text-xl" data-id="element-97" data-mp="x0uxq9slif2s">
            Hangeul · Aussprache · Wortschatz · K-Drama-Ausdrücke · K-Visual System
          </motion.h2>

          <div className="mt-6 flex flex-wrap justify-center gap-2.5" data-id="element-98" data-mp="21bxy9551wsbc">
            {heroChips.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5 rounded-full border border-grape/20 bg-white/70 px-3.5 py-1.5 text-xs font-semibold text-plum/80" data-id="element-99" data-mp="26868c44e5vbn">
                <Icon className="h-3.5 w-3.5 text-grape" data-id="element-100" data-mp="2fzj1r05u8tjs" />
                {label}
              </span>)}
          </div>

          <p className="mt-4 text-sm font-semibold text-plum/50" data-id="element-101" data-mp="2l0qap2jpvys1">
            eBook + 5 Boni · 120+ Seiten — Alles, was du brauchst, an einem Ort.
          </p>
        </div>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs font-medium text-plum/55" data-id="element-102" data-mp="2tz1zcz10wmhu">
          {heroTrust.map(({
          icon: Icon,
          label
        }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-103" data-mp="zm2n9fvuqafb">
              <Icon className="h-4 w-4 text-grape" data-id="element-104" data-mp="4acm5ch3dp7f" />
              {label}
            </span>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.05,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-5 inline-flex items-center gap-2 rounded-full border border-blush/50 bg-blush-soft px-4 py-1.5 text-xs font-bold uppercase tracking-wide text-blush-deep" data-id="element-105" data-mp="3vgnjoymw87u0">
          🔥 Begrenztes Angebot: 19€ Startpreis · Danach 38€
        </motion.div>

        <p className="mt-4 inline-flex items-center justify-center gap-1.5 text-xs font-medium text-plum/45" data-id="element-106" data-mp="3rglrdg31sqre">
          <EyeIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-107" data-mp="3mp3qst4xss6y" />
          27 Personen sehen sich dieses Produkt gerade an
        </p>
      </div>
    </header>;
}